/* eslint no-mixed-operators:0 */
/* eslint no-shadow:0 */
import helpers from '@/utils/helpers';
import moment from 'moment';
import { validateNationalId } from '@/utils/paValidation';

const required = (propertyType) => (v) => v && v.length > 0 || `${propertyType} field is required`;

const minLength = (propertyType, minLength) => (v) => (v === '' || v && v.length >= minLength) || `${propertyType} must not be less than ${minLength} characters`;

const confirmPassword = (propertyType, password) => (v) => v && v === password || `${propertyType} must be same as entered password`;

const maxLength = (propertyType, maxLength) => (v) => v && v.length <= maxLength || `${propertyType} must be less than ${maxLength}`;

const max = (propertyType, max) => (v) => v && v <= max || `${propertyType} must not be more than ${max}`;

const maxAge = (propertyType, max) => (v) => {
  const dob = moment(v, 'DD/MM/YYYY');
  // return dob.isValid() && moment().diff(dob, 'years', false) <= max || `${propertyType} must not be more than ${max} years`;
  return dob.isValid() && moment().diff(dob, 'years', false) <= max || `${propertyType} must not be more than 64 years next birthday`;
};

const min = (propertyType, min) => (v) => v && v >= min || `${propertyType} must be ${min} or more`;

const minAmount = (propertyType, num) => (v) => helpers.stringToNumber(v) && helpers.stringToNumber(v) >= num || `${propertyType} must be Ksh ${helpers.numberToString(num)} or more`;

const emailFormat = () => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  return (v) => v && regex.test(v) || 'Must be a valid email';
};

const mobileFormat = () => {
  const regex = /^\+254\d{9}$/; // [- ]?
  return (v) => v && regex.test(v) || 'Must start with +254...';
};

/** Kenyan mobile: 07XXXXXXXX, +2547XXXXXXXX, or 2547XXXXXXXX */
const kenyaMobileFormat = () => (v) => {
  const digits = String(v || '').replace(/\D/g, '');
  if (digits.startsWith('254') && digits.length === 12) return true;
  if (digits.startsWith('0') && digits.length === 10) return true;
  if (digits.startsWith('7') && digits.length === 9) return true;
  return 'Enter a valid mobile (07… or +254…)';
};

const internationalMobileFormat = () => {
  // Supports international phone numbers starting with +
  const regex = /^\+[1-9]\d{1,14}$/; // ITU-T E.164 format
  return (v) => v && regex.test(v) || 'Must be a valid international phone number starting with +';
};

const kraPinFormat = () => {
  const regex = /^a\d{9}[a-z]$/i;
  return (v) => v && regex.test(v) || 'Must be a valid KRA PIN';
};

/** Kenya National ID: 8 or 9 digits. Pass true to allow an empty value. */
const nationalIdFormat = (optional = false) => (v) => {
  if (!v && optional) return true;
  const result = validateNationalId(v);
  return result.valid || result.message;
};

const numberFormat = () => {
  const regex = /^[0-9]+$/;
  return (v) => v && regex.test(v) || 'Must be a valid number';
};

const lowerCaseFormat = () => {
  const regex = /^(.*[a-z].*)$/;
  return (v) => v && regex.test(v) || 'Must have at least 1 lowercase character';
};
const upperCaseFormat = () => {
  const regex = /^(.*[A-Z].*)$/;
  return (v) => v && regex.test(v) || 'Must have at least 1 uppercase character';
};

const digitFormat = () => {
  const regex = /^(.*[0-9].*)$/;
  return (v) => v && regex.test(v) || 'Must have at least 1 digit';
};

const specialCharFormat = () => {
  const regex = /^(.*[!@#$%^&*)(+=.,_-].*)$/;
  return (v) => v && regex.test(v) || 'Must have at least 1 special character';
};

const numberPlateFormat = () => {
  const regex = /^[A-Za-z]{3}(.*?)[0-9]{3}(.*?)[A-Za-z]{1}$/;
  return (v) => v && regex.test(v) || 'Registration Number must be valid';
};

const isObjectField = () => (v) => v && typeof v === 'object' || 'Must be valid object';

const check = () => (v) => v === true || 'You must agree to continue!';

const checkAge = (age, dob) => {
  const dobAge = moment().diff(dob, 'years', false);
  return (v) => v && (dobAge >= (age - 1) && dobAge <= age) || 'Date Of Birth should be equal to given age';
};

export default {
  required,
  minLength,
  maxLength,
  emailFormat,
  numberFormat,
  kraPinFormat,
  nationalIdFormat,
  confirmPassword,
  check,
  mobileFormat,
  kenyaMobileFormat,
  internationalMobileFormat,
  lowerCaseFormat,
  minAmount,
  max,
  min,
  isObjectField,
  numberPlateFormat,
  upperCaseFormat,
  digitFormat,
  specialCharFormat,
  checkAge,
  maxAge,
};
